if (!customElements.get('modal-variant-preview')) {
  class ModalVariantPreview extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.imgElm = this.querySelector('.variant_modal__img');
      this.closeBtn = this.querySelector('.variant_modal__close');

      this.closeBtn?.addEventListener('click', () => this.close());

      this.addEventListener('click', (e) => {
        if (e.target === this) this.close();
      });
    }

    open() {
      this.removeAttribute('hidden');

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.close();
      }, { once: true });
    }

    close() {
      this.setStyle({
        paddingTop: 'initial',
        paddingBottom: 'initial',
      });
      this.setAttribute('hidden', '');
    }

    setImgSrc(src) {
      if (this.imgElm) this.imgElm.src = src;
    }

    setStyle(styles) {
      for (let property in styles) {
        this.style[property] = styles[property];
      }
    }
  }

  customElements.define('modal-variant-preview', ModalVariantPreview);
}


document.addEventListener('DOMContentLoaded', () => {
  const variantImages = document.querySelectorAll('.swatch-elements .swatch-element.color');
  const modal = document.querySelector('modal-variant-preview');

  if (modal) {
    variantImages.forEach(item => {
      item.addEventListener('click', debounce(() => handleItemClick(item), 300));
    });
  }

  function handleItemClick(item) {
    const screenHeight = window.screen.height;
    const screenWidth = window.screen.width;
    const variantInput = item.querySelector('input');
    const popupImageSrc = variantInput?.dataset.vImage;

    if (!variantInput || !popupImageSrc) return;

    modal.setImgSrc(popupImageSrc);

    setTimeout(() => {
      if (screenWidth < 700) {
        const imageHeight = modal.imgElm.height;
        const remainingHeight = screenHeight - imageHeight;
        const remainingDivided = remainingHeight / 2;
        modal.setStyle({
          paddingTop: `${remainingDivided}px`,
          paddingBottom: `${remainingDivided}px`
        });
      }

      modal.open();
    }, 300);
  }

  function debounce(func, delay) {
    let debounceTimer;
    return function() {
      const context = this;
      const args = arguments;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => func.apply(context, args), delay);
    }
  }
});
